const standardsConfig = {
  '7-10': {
    label: 'ASCE/SEI 7-10',
    seismicQueryUrl: 'https://earthquake.usgs.gov/ws/designmaps/asce7-10.json',
    soilClasses: [
      'A - Hard Rock',
      'B - Rock',
      'C - Very Dense Soil and Soft Rock',
      'D - Stiff Soil',
      'E - Soft Clay Soil',
      'F - Site Response Analysis',
    ],
    soilClassText: {
      0: 'A - Hard Rock',
      1: 'B - Rock',
      2: 'C - Very Dense Soil and Soft Rock',
      3: 'D - Stiff Soil',
      4: 'E - Soft Clay Soil',
      5: 'F - Site Response Analysis',
    },
    coefficients: [
      {
        label: 'SS',
        value: null,
      },
      {
        label: 'S1',
        value: null,
      },
      {
        label: 'FA',
        value: null,
      },
      {
        label: 'FV',
        value: null,
      },
      {
        label: 'SMS',
        value: null,
      },
      {
        label: 'SM1',
        value: null,
      },
      {
        label: 'SDS',
        value: null,
      },
      {
        label: 'SD1',
        value: null,
      },
      {
        label: 'TL',
        service_key: 't-sub-l',
        value: null,
      },
      {
        label: 'PGA',
        value: null,
      },
      {
        label: 'PGAM',
        value: null,
      },
      {
        label: 'FPGA',
        value: null,
      },
      {
        label: 'LE',
        value: null,
      },
    ],
    iceNotes: {
      type: 'note',
      note: 'Values provided are equivalent radial ice thicknesses due to freezing rain with concurrent 3-second gust speeds, for a 50-year mean recurrence interval, and temperatures concurrent with ice thicknesses due to freezing rain. Thicknesses for ice accretions caused by other sources shall be obtained from local meteorological studies. Ice thicknesses in exposed locations at elevations higher than the surrounding terrain and in valleys and gorges may exceed the mapped values.',
    },
    iceQueryLayerId: 0,
    gustSpeed: 'Gust Speed',
    windDebrisUrl: 'https://gis.asce.org/arcgis/rest/services/ASCE/ASCE_Hurricane_WindBorneDebris/MapServer/3',
    dataSource:
      'USGS Seismic Design Maps based on ASCE/SEI 7-10, incorporating Supplement 1 and errata of March 31, 2013, and ASCE/SEI 7-10 Table 1.5-2. Additional data for site-specific ground motion procedures in accordance with ASCE/SEI 7-10 Ch. 21 are available from USGS.',
    tsunamiDataSource: 'ASCE Tsunami Design Geodatabase',
    tsunamiDataSourceLink: 'http://asce7tsunami.online',
    tsunamiQueryLayerId: 0,
  },
  '7-16': {
    label: 'ASCE/SEI 7-16',
    seismicQueryUrl: 'https://earthquake.usgs.gov/ws/designmaps/asce7-16.json',
    soilClasses: [
      'A - Hard Rock',
      'B - Rock',
      'B - Estimated (see Section 11.4.3)',
      'C - Very Dense Soil and Soft Rock',
      'D - Stiff Soil',
      'D - Default (see Section 11.4.3)',
      'E - Soft Clay Soil',
      'F - Site Response Analysis',
    ],
    soilClassText: {
      0: 'A - Hard Rock',
      1: 'B - Rock',
      2: 'B - Estimated (see Section 11.4.3)',
      3: 'C - Very Dense Soil and Soft Rock',
      4: 'D - Stiff Soil',
      5: 'D - Default (see Section 11.4.3)',
      6: 'E - Soft Clay Soil',
      7: 'F - Site Response Analysis',
    },
    coefficients: [
      {
        label: 'SS',
        value: null,
      },
      {
        label: 'S1',
        value: null,
      },
      {
        label: 'Fa',
        value: null,
      },
      {
        label: 'Fv',
        value: null,
      },
      {
        label: 'SMS',
        value: null,
      },
      {
        label: 'SM1',
        value: null,
      },
      {
        label: 'SDS',
        value: null,
      },
      {
        label: 'SD1',
        value: null,
      },
      {
        label: 'TL',
        service_key: 't-sub-l',
        value: null,
      },
      {
        label: 'PGA',
        value: null,
      },
      {
        label: 'PGAM',
        value: null,
      },
      {
        label: 'FPGA',
        value: null,
      },
      {
        label: 'le',
        value: null,
      },
      {
        label: 'Cv',
        value: null,
      },
    ],
    iceQueryLayerId: 1,
    iceNotes: {
      type: 'note',
      note: 'Values provided are equivalent radial ice thicknesses due to freezing rain with concurrent 3-second gust speeds, for a 500-year mean recurrence interval, and temperatures concurrent with ice thicknesses due to freezing rain. Thicknesses for ice accretions caused by other sources shall be obtained from local meteorological studies. Ice thicknesses in exposed locations at elevations higher than the surrounding terrain and in valleys and gorges may exceed the mapped values.',
    },
    gustSpeed: 'Gust Speed',
    windDebrisUrl: 'https://gis.asce.org/arcgis/rest/services/ASCE/ASCE_Hurricane_WindBorneDebris/MapServer/2',
    dataSource:
      'USGS Seismic Design Maps based on ASCE/SEI 7-16 and ASCE/SEI 7-16 Table 1.5-2. Additional data for site-specific ground motion procedures in accordance with ASCE/SEI 7-16 Ch. 21 are available from USGS.',
    tsunamiDataSource: 'ASCE Tsunami Design Geodatabase',
    tsunamiDataSourceLink: 'http://asce7tsunami.online',
    tsunamiQueryLayerId: 6,
  },
  '7-22': {
    label: 'ASCE/SEI 7-22',
    seismicQueryUrl: 'https://earthquake.usgs.gov/ws/designmaps/nehrp-2020.json',
    soilClasses: [
      'Default',
      'A - Hard Rock',
      'B - Rock',
      'BC',
      'C - Very Dense Soil and Soft Rock',
      'CD',
      'D - Stiff Soil',
      'DE',
      'E - Soft Clay Soil',
    ],
    soilClassText: {
      0: 'Default',
      1: 'A - Hard Rock',
      2: 'B - Rock',
      3: 'BC',
      4: 'C - Very Dense Soil and Soft Rock',
      5: 'CD',
      6: 'D - Stiff Soil',
      7: 'DE',
      8: 'E - Soft Clay Soil',
    },
    coefficients: [
      {
        label: 'PGAM',
        value: null,
      },
      {
        label: 'SMS',
        value: null,
      },
      {
        label: 'SM1',
        value: null,
      },
      {
        label: 'SDS',
        value: null,
      },
      {
        label: 'SD1',
        value: null,
      },
      {
        label: 'TL',
        service_key: 't-sub-l',
        value: null,
      },
      {
        label: 'SS',
        value: null,
      },
      {
        label: 'S1',
        value: null,
      },
      {
        label: 'SDC',
        value: null,
      },
      {
        label: 'VS30',
        value: null,
      },
    ],
    iceNotes: {
      type: 'note',
      note: 'Values provided are equivalent radial ice thicknesses due to freezing rain for 250, 500, 1,000, and 1,400-year mean recurrence intervals along with concurrent 3-s gust speeds and concurrent air temperatures. The shading indicates special icing regions, with elevations above 2,100 ft (640 m) in the east, 6,000 ft (1829 m) in the west, and 1,600 ft (488 m) in Alaska, with sparse weather station data for determining design ice loads. In these regions, as well as in regions with complex terrain causing unusual icing conditions and regions where snow or in-cloud icing results in larger loads, the mapped values should be adjusted based on a combination of local historical records and experience, reanalysis data, and numerical weather prediction systems.',
    },
    gustSpeed: '3-s Gust Speed',
    windDebrisUrl: 'https://gis.asce.org/arcgis/rest/services/ASCE/ASCE_Hurricane_WindBorneDebris/MapServer/2',
    islandTerritories: ['American Samoa', 'Guam', 'Northern Mariana Islands'],
    dataSource:
      'USGS Seismic Design Maps based on ASCE/SEI 7-22 and ASCE/SEI 7-22 Table 1.5-2. Additional data for site-specific ground motion procedures in accordance with ASCE/SEI 7-22 Ch. 21 are available from USGS.',
    tsunamiDataSource: 'ASCE Tsunami Design Geodatabase Version 2022-1.0',
    tsunamiDataSourceLink: 'https://asce7tsunami.online/',
    iceServices: {
      riskCategory1: 'https://gis.asce.org/arcgis/rest/services/ASCE722/i2022_mri0250/ImageServer',
      riskCategory2: 'https://gis.asce.org/arcgis/rest/services/ASCE722/i2022_mri0500/ImageServer',
      riskCategory3: 'https://gis.asce.org/arcgis/rest/services/ASCE722/i2022_mri1000/ImageServer',
      riskCategory4: 'https://gis.asce.org/arcgis/rest/services/ASCE722/i2022_mri1400/ImageServer',
      temp: 'https://gis.asce.org/arcgis/rest/services/ASCE722/i2022_ConcurrentTemp/MapServer/0',
      specialZones: 'https://gis.asce.org/arcgis/rest/services/ASCE722/i2022_SpecialZonesElevation/MapServer/0',
      gust: 'https://gis.asce.org/arcgis/rest/services/ASCE722/i2022_gust/ImageServer',
    },
    snowServices: {
      mri20yr: 'https://gis.asce.org/arcgis/rest/services/ASCE722/s2022_20yrMRI/ImageServer',
      elevation: 'https://gis.asce.org/arcgis/rest/services/ASCE722/s2022_Elevation/ImageServer',
      riskCategory1: 'https://gis.asce.org/arcgis/rest/services/ASCE722/s2022_RiskCategory1/ImageServer',
      riskCategory2: 'https://gis.asce.org/arcgis/rest/services/ASCE722/s2022_RiskCategory2/ImageServer',
      riskCategory3: 'https://gis.asce.org/arcgis/rest/services/ASCE722/s2022_RiskCategory3/ImageServer',
      riskCategory4: 'https://gis.asce.org/arcgis/rest/services/ASCE722/s2022_RiskCategory4/ImageServer',
      winterWind: 'https://gis.asce.org/arcgis/rest/services/ASCE722/s2022_Winter_Wind/MapServer/0',
      alaska: 'https://gis.asce.org/arcgis/rest/services/ASCE722/s2022_AlaskaCaseStudy/MapServer/0',
    },
    windServices: {
      reoccurences: {
        10: 'https://gis.asce.org/arcgis/rest/services/ASCE722/w2022_mri10/ImageServer',
        25: 'https://gis.asce.org/arcgis/rest/services/ASCE722/w2022_mri25/ImageServer',
        50: 'https://gis.asce.org/arcgis/rest/services/ASCE722/w2022_mri50/ImageServer',
        100: 'https://gis.asce.org/arcgis/rest/services/ASCE722/w2022_mri100/ImageServer',
        10000: 'https://gis.asce.org/arcgis/rest/services/ASCE722/w2022_mri10000/ImageServer',
        100000: 'https://gis.asce.org/arcgis/rest/services/ASCE722/w2022_mri100000/ImageServer',
        1000000: 'https://gis.asce.org/arcgis/rest/services/ASCE722/w2022_mri1000000/ImageServer',
      },
      riskCategory1: 'https://gis.asce.org/arcgis/rest/services/ASCE722/w2022_mri300/ImageServer',
      riskCategory2: 'https://gis.asce.org/arcgis/rest/services/ASCE722/w2022_mri700/ImageServer',
      riskCategory3: 'https://gis.asce.org/arcgis/rest/services/ASCE722/w2022_mri1700/ImageServer',
      riskCategory4: 'https://gis.asce.org/arcgis/rest/services/ASCE722/w2022_mri3000/ImageServer',
      specialWindRegions: 'https://gis.asce.org/arcgis/rest/services/ASCE722/w2022_Special_Wind_Regions/MapServer/0',
      windServiceDataset: 'https://gis.asce.org/arcgis/rest/services/ASCE722/w2022_CONUS_Mosaic/ImageServer',
      windServicePRDataset: 'https://gis.asce.org/arcgis/rest/services/ASCE722/w2022_PR_Mosaic/ImageServer',
      specialWindRegionMosaicDatasets: [
        'https://gis.asce.org/arcgis/rest/services/ASCE722/w2022_SWR_CA/ImageServer',
        'https://gis.asce.org/arcgis/rest/services/ASCE722/SWR_CO_Mosaic_1007/ImageServer',
      ],
      riskCategoryMRIDictionary: {
        riskCategory1: 300,
        riskCategory2: 700,
        riskCategory3: 1700,
        riskCategory4: 3000,
      },
    },
    tornadoServices: {
      aeValues: ['PT', '2K', '10K', '40K', '100K', '250K', '1M', '4M'],
      mriValues: ['1700', '3K', '10K', '100K', '1M', '10M'],
      tornadoProneAreas: 'https://gis.asce.org/arcgis/rest/services/ASCE722/t2022_tornado_prone_area/MapServer/0',
    },
    tsunamiServices: {
      tsunamiDesignZone:
        'https://gis.asce.org/arcgis/rest/services/ASCE722/ts2022_Tsunami_Feature_Services/MapServer/4',
      overlay: 'https://gis.asce.org/arcgis/rest/services/ASCE722/ts2022_Tsunami_Tile/MapServer/0',
    },
  },
  '41-17': {
    label: 'ASCE/SEI 41-17',
    seismicQueryUrl: 'https://earthquake.usgs.gov/ws/designmaps/asce41-17.json',
    soilClasses: [
      'A - Hard Rock',
      'B - Rock',
      'C - Very Dense Soil and Soft Rock',
      'D - Stiff Soil',
      'E - Soft Clay Soil',
      'F - Site Response Analysis',
    ],
    soilClassText: {
      0: 'A - Hard Rock',
      1: 'B - Rock',
      2: 'C - Very Dense Soil and Soft Rock',
      3: 'D - Stiff Soil',
      4: 'E - Soft Clay Soil',
      5: 'F - Site Response Analysis',
    },
  },
  '41-23': {
    label: 'ASCE/SEI 41-23',
    seismicQueryUrl: 'https://earthquake.usgs.gov/ws/nshmp/designmaps/asce41-23/calculate',
    soilClasses: [
      'Default',
      'A - Hard Rock',
      'B - Rock',
      'BC',
      'C - Very Dense Soil and Soft Rock',
      'CD',
      'D - Stiff Soil',
      'DE',
      'E - Soft Clay Soil',
    ],
    soilClassText: {
      0: 'Default',
      1: 'A - Hard Rock',
      2: 'B - Rock',
      3: 'BC',
      4: 'C - Very Dense Soil and Soft Rock',
      5: 'CD',
      6: 'D - Stiff Soil',
      7: 'DE',
      8: 'E - Soft Clay Soil',
    },
  },
};

export default standardsConfig;
